export default __webpack_public_path__ + "static/media/salesforce-logo.46a5d095.png";